export const QR_TYPES = {
  WORKER: 'worker',
  FARM: 'farm',
  DEVICE: 'device',
  BLOCK: 'block',
  ROW: 'row',
  STICKER: 'sticker'
}
